import darkBaseTheme from "./darkBaseTheme";
import lightBaseTheme from "./lightBaseTheme";
import palette from "./shared/palette";
import legacyTheme from "./legacyTheme";

const darkBaseThemeWithLegacy = {
  ...darkBaseTheme,
  ...legacyTheme };


const lightBaseThemeWithLegacy = {
  ...lightBaseTheme,
  ...legacyTheme };


export {
darkBaseThemeWithLegacy as darkBaseTheme,
lightBaseThemeWithLegacy as lightBaseTheme,
// This export is needed for backward compability
lightBaseThemeWithLegacy as defaultTheme,
palette };